export enum BrokerAccountStatus {
  NotFilled = 'NOT_FILLED',
  Valid = 'VALID',
  Invalid = 'INVALID',
}
